export const customerFormSubmissions = ({ dispatch }) => next => (action) => {
    next(action);
};
